"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assignQeId = exports.HeroBanner = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CorpPrimaryContainer = require("./variants/IntlCommercial/CorpPrimaryContainer");
var _CorpSecondaryContainer = require("./variants/IntlCommercial/CorpSecondaryContainer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var assignQeId = exports.assignQeId = function assignQeId(contentComponent, contentString) {
  var qeId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var qeIdKey = typeof contentComponent === 'string' ? 'data-qe-id' : 'qeId';
  return _defineProperty({}, qeIdKey, "".concat(qeId).concat(contentString));
};
var HeroBanner = exports.HeroBanner = function HeroBanner(_ref2) {
  var PrimaryContentComponent = _ref2.PrimaryContentComponent,
    SecondaryContentComponent = _ref2.SecondaryContentComponent,
    TertiaryContentComponent = _ref2.TertiaryContentComponent,
    primaryContentProps = _ref2.primaryContentProps,
    secondaryContentProps = _ref2.secondaryContentProps,
    tertiaryContentProps = _ref2.tertiaryContentProps,
    primaryContainerClassName = _ref2.primaryContainerClassName,
    secondaryContainerClassName = _ref2.secondaryContainerClassName,
    tertiaryContainerClassName = _ref2.tertiaryContainerClassName,
    styles = _ref2.styles,
    namespace = _ref2.namespace,
    qeId = _ref2.qeId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bannerWrapper,
    "data-qe-id": qeId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.backgroundImageContainer
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.bannerContentContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.primarySectionContainer, _defineProperty({}, primaryContainerClassName, primaryContainerClassName))
  }, /*#__PURE__*/_react["default"].createElement(PrimaryContentComponent, _extends({}, primaryContentProps, {
    namespace: namespace
  }, assignQeId(PrimaryContentComponent, '__primaryContainer', qeId)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.secondarySectionContainer, _defineProperty({}, secondaryContainerClassName, secondaryContainerClassName))
  }, /*#__PURE__*/_react["default"].createElement(SecondaryContentComponent, _extends({}, secondaryContentProps, {
    namespace: namespace
  }, assignQeId(SecondaryContentComponent, '__secondaryContainer', qeId)))), TertiaryContentComponent && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.tertiarySectionContainer, _defineProperty({}, tertiaryContainerClassName, tertiaryContainerClassName))
  }, /*#__PURE__*/_react["default"].createElement(TertiaryContentComponent, _extends({}, tertiaryContentProps, {
    namespace: namespace
  }, assignQeId(TertiaryContentComponent, '__tertiaryContainer', qeId)))))));
};
HeroBanner.propTypes = {
  PrimaryContentComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].object]),
  SecondaryContentComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].object]),
  TertiaryContentComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node, _propTypes["default"].object]),
  primaryContentProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  secondaryContentProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  tertiaryContentProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  primaryContainerClassName: _propTypes["default"].string,
  secondaryContainerClassName: _propTypes["default"].string,
  tertiaryContainerClassName: _propTypes["default"].string,
  styles: _propTypes["default"].shape({
    bannerWrapper: _propTypes["default"].string,
    backgroundImageContainer: _propTypes["default"].string,
    primarySectionContainer: _propTypes["default"].string,
    secondarySectionContainer: _propTypes["default"].string,
    bannerContentContainer: _propTypes["default"].string
  }),
  namespace: _propTypes["default"].string,
  qeId: _propTypes["default"].string
};
HeroBanner.defaultProps = {
  PrimaryContentComponent: _CorpPrimaryContainer.CorpPrimaryContainer,
  SecondaryContentComponent: _CorpSecondaryContainer.CorpSecondaryContainer,
  TertiaryContentComponent: null,
  primaryContentProps: {
    src: '',
    alt: ''
  },
  secondaryContentProps: {
    textComponents: {},
    textComponentStyles: {},
    footer: {},
    primaryButtonProps: {
      children: ''
    },
    secondaryButtonProps: {
      children: ''
    }
  },
  tertiaryContentProps: {},
  primaryContainerClassName: '',
  secondaryContainerClassName: '',
  tertiaryContainerClassName: '',
  styles: {},
  namespace: '',
  qeId: undefined
};